module.exports = __webpack_public_path__ + "static/media/rs.47db2511.svg";